/** Entry point. Mounts <App/> into #app, wires the auto-save effect, and
 *  hydrates the local cache so reloads feel instant. */
import { render } from "preact";
import { App } from "./App";
import { attachAutoSave, loadCachedState } from "./state/storage";
import { state } from "./state/store";

import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/views.css";

// Hydrate from offline cache (kept in sync by storage.ts). The signal
// gets overwritten by bootFromSupabase as soon as the auth listener fires
// — but until then, the user sees their last-known calendar.
const cached = loadCachedState();
if (cached) state.value = cached;

attachAutoSave();

const root = document.getElementById("app");
if (!root) throw new Error("#app element missing from index.html");
root.removeAttribute("aria-busy");
render(<App />, root);

// Tear down the inline boot screen once the first Preact render commits.
// Use a microtask so the app's first frame paints before the boot screen
// fades out — prevents a flash of empty page between the two.
queueMicrotask(() => {
  const boot = document.getElementById("boot-screen");
  if (!boot) return;
  boot.classList.add("hide");
  // Remove from DOM after the fade so it doesn't intercept any clicks.
  setTimeout(() => boot.remove(), 400);
});
